import api from 'api'
import { Button, Icon, Tooltip } from 'bold-ui'
import { useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { useState } from 'react'
import { normalizeText } from 'util/string/string-normalizeText'

import { AssinaturaEletronicaAtendTableRowModel } from '../model-assinaturaEletronicaAtend'

interface BaixarAtendimentoDigitalButtonProps {
  readonly row: AssinaturaEletronicaAtendTableRowModel
}

export function BaixarAtendimentoDigitalButton({ row }: BaixarAtendimentoDigitalButtonProps) {
  const { handleImpressaoPath, handleImpressaoError } = useHandleImpressao<{
    atendimentoProfissionalId: ID
  }>()
  const [isDownloading, setIsDownloading] = useState(false)

  const nomeCidadao = normalizeText(row.cidadao?.nomeSocial ?? row.cidadao?.nome ?? '').replace(/\s+/g, '_')

  const handleDownload = () => {
    setIsDownloading(true)
    handleImpressaoPath({
      apiPath: api.atendimentoDigital.baixarAtendimentoDigital,
      values: { atendimentoProfissionalId: row.id },
      file: `RegistroAssinado_${nomeCidadao}`,
      dateFormat: 'dd-MM-yyyy',
      downloadType: 'download',
    })
      .catch((error) => handleImpressaoError(error, 'Não foi possível baixar o documento assinado. Tente novamente.'))
      .finally(() => setIsDownloading(false))
  }

  return (
    <Tooltip
      text={row.isAtendimentoAssinado ? 'Baixar documento assinado' : 'Documento ainda não assinado'}
      placement='bottom'
    >
      <Button size='small' skin='ghost' disabled={!row.isAtendimentoAssinado || isDownloading} onClick={handleDownload}>
        <Icon icon='download' fill='normal' />
      </Button>
    </Tooltip>
  )
}
